var exports = {
  "iE": "xaee3c4fa--6f9fbd--wrapper",
  "jm": "xaee3c4fa--6f9fbd--breadcrumbs-wrapper",
  "nf": "xaee3c4fa--6f9fbd--link",
  "Qq": "xaee3c4fa--6f9fbd--text",
  "uV": "xaee3c4fa--6f9fbd--delimiter",
  "nI": "xaee3c4fa--6f9fbd--rss",
};

module.exports = exports;
